jQuery(document).ready(function () {

  jQuery('.product-list .product-card__info').each(function () {
    var $widget = jQuery(this).find('.jdgm-widget');
    var $priceList = jQuery(this).find('price-list');

    if ($widget.length && $priceList.length) {
      $priceList.before($widget);
    }
  });
  
  // Listen for click event on .product-info__block-item .link
  jQuery(".product-info__block-item .link").click(function () {
    // Set a delay of 5 seconds before injecting the video into the modal
    setTimeout(function () {
      jQuery(".modal--lg .prose").html(
        '<video autoplay><source src="https://cdn.shopify.com/videos/c/o/v/47e9fe52f7a543408bf935820d98f434.mp4" type="video/mp4"></video>'
      );
    }, 2000);
  });
});

function updateVisitorCount() {
  var vistorCountElement = document.querySelector("#vistorCount.product__text"),
    currentHourElement = document.querySelector("#currentHour");
  if (vistorCountElement && currentHourElement) {
    (vistorCountElement.style.display = "flex"),
      (currentHourElement.style.display = "none");
    // var randomCount = Math.floor(Math.random() * 201) + 300,
    var randomCount = Math.floor(Math.random() * 20) + 30,
      strongElement = vistorCountElement.querySelector("strong");
    strongElement && (strongElement.innerText = randomCount);
  }
}
// function updateCurrentHour() {
//   var vistorCountElement = document.querySelector("#vistorCount.product__text"),
//     currentHourElement = document.querySelector("#currentHour");
//   if (currentHourElement && vistorCountElement) {
//     (currentHourElement.style.display = "flex"),
//       (vistorCountElement.style.display = "none");
//     var currentDate = new Date(),
//       currentHour = currentDate.getHours(),
//       currentMinute = currentDate.getMinutes();
//     currentHour = currentHour % 12 || 12;
//     var totalMinutes = currentHour * 60 + currentMinute,
//       outputValue = totalMinutes < 400 ? 450 + currentMinute : totalMinutes,
//       outputValue = totalMinutes < 4 ? 4 + currentMinute : totalMinutes,
//       productId = meta.product.id,
//       lastDigit = productId % 10;
//     outputValue += lastDigit;
//     var strongElement = currentHourElement.querySelector("strong");
//     strongElement && (strongElement.innerText = outputValue);
//   }
// }

// AIS New JS Code for Trending text 24/11/2025
// Store the trending count globally so it keeps increasing
var trendingCount = null;
var lastUpdateTime = null;

function updateCurrentHour() {
  var vistorCountElement = document.querySelector("#vistorCount.product__text"),
      currentHourElement = document.querySelector("#currentHour");

  if (currentHourElement && vistorCountElement) {
    currentHourElement.style.display = "flex";
    vistorCountElement.style.display = "none";

    var strongElement = currentHourElement.querySelector("strong");

    if (strongElement) {
      var now = Date.now();

      // Initialize first value: random between 20–35
      if (trendingCount === null) {
        trendingCount = Math.floor(Math.random() * (35 - 20 + 1)) + 20;
        lastUpdateTime = now;
      }

      // Check if 15 minutes have passed (15 mins = 900000 ms)
      if (now - lastUpdateTime >= 900000) {
        // Increase by 1 in ascending order
        trendingCount++;

        // Don't exceed 35
        if (trendingCount > 35) trendingCount = 35;

        lastUpdateTime = now;
      }

      strongElement.innerText = trendingCount;
    }
  }
}

updateVisitorCount();
var showingVisitorCount = !0;
setInterval(function () {
  showingVisitorCount ? updateCurrentHour() : updateVisitorCount(),
    (showingVisitorCount = !showingVisitorCount);
}, 3e3);


// function checkForStitchedVariant() {
//   fetch('/cart.js')
//     .then(response => response.json())
//     .then(cart => {
//       const stitchedFound = cart.items.some(item =>
//         item.variant_title && item.variant_title.toLowerCase().includes("stitched")
//       );

//       const messageEl = document.getElementById("stitched-message");

//       if (!messageEl) return; // safety check

//       if (stitchedFound) {
//         messageEl.style.display = "block";  // show message
//       } else {
//         messageEl.style.display = "none";   // hide message
//       }
//     });
// }

// // Run check on page load
// checkForStitchedVariant();

// // Re-check whenever cart drawer opens or changes
// document.addEventListener("cart:updated", checkForStitchedVariant);
// document.addEventListener("cart:refresh", checkForStitchedVariant);
// document.addEventListener("cart:change", checkForStitchedVariant);

function checkForStitchedVariant() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      console.log('Cart items:', cart.items);
      
      const stitchedFound = cart.items.some(item => {
        const variantTitle = item.variant_title ? item.variant_title.toLowerCase() : '';
        console.log('Checking variant:', item.title, 'with variant_title:', variantTitle);
        // Check for "stitched" as a complete word, not part of "unstitched"
        return /\bstitched\b/.test(variantTitle);
      });

      console.log('Stitched found:', stitchedFound);

      const messageEl = document.getElementById('stitched-message');

      if (!messageEl) {
        console.warn('Element #stitched-message not found');
        return;
      }

      if (stitchedFound) {
        messageEl.style.display = 'block';
        console.log('Message shown');
      } else {
        messageEl.style.display = 'none';
        console.log('Message hidden');
      }
    })
    .catch(error => console.error('Error fetching cart:', error));
}

// Run on page load
document.addEventListener('DOMContentLoaded', checkForStitchedVariant);

// Listen to multiple possible events
document.addEventListener('cart:updated', checkForStitchedVariant);
document.addEventListener('cart-updated', checkForStitchedVariant);
document.addEventListener('cart:change', checkForStitchedVariant);

// Prestige theme specific listeners
document.addEventListener('drawer:open', checkForStitchedVariant);

// Universal MutationObserver - watch for cart changes
const cartObserver = new MutationObserver(() => {
  console.log('Cart drawer DOM changed, rechecking...');
  checkForStitchedVariant();
});

// Start observing the cart drawer when page loads
document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('[id*="cart"]') || document.querySelector('.drawer');
  if (cartDrawer) {
    cartObserver.observe(cartDrawer, {
      childList: true,
      subtree: true,
      characterData: true
    });
    console.log('Cart observer started');
  }
});

